import type { FeatureSuggestItem } from '@services/chatService';

export interface AtMentionQuery {
  isTriggered: boolean;
  query: string;
}

const normalizeSearchText = (value: string): string => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/đ/g, 'd')
  .replace(/Đ/g, 'D')
  .toLowerCase();

const stripTendooPrefix = (query: string): string => {
  const normalized = normalizeSearchText(query);
  if (/^(t|te|ten|tend)$/.test(normalized)) return '';
  if (!normalized.startsWith('tendo')) return query;
  const prefix = /^tendoo?[,\s]*/i.exec(query);
  return prefix ? query.slice(prefix[0].length).trim() : query;
};

export const parseAtMentionQuery = (input: string): AtMentionQuery => {
  const trimmed = input.trim();
  if (!trimmed.startsWith('@')) return { isTriggered: false, query: '' };
  const query = stripTendooPrefix(trimmed.slice(1).trim());
  return { isTriggered: true, query };
};

export const formatFeatureSuggestion = (item: FeatureSuggestItem): string => (
  item.businessCode ? `${item.businessCode}, ${item.featureName}` : item.featureName
);

export const filterFeatureSuggestions = (
  items: FeatureSuggestItem[],
  query: string,
): FeatureSuggestItem[] => {
  const normalizedQuery = normalizeSearchText(query.trim());
  if (!normalizedQuery) return items;
  return items.filter((item) => {
    const name = normalizeSearchText(item.featureName);
    const command = normalizeSearchText(formatFeatureSuggestion(item));
    return name.includes(normalizedQuery) || command.includes(normalizedQuery);
  });
};
